import { render, staticRenderFns } from "./vin.vue?vue&type=template&id=1c6eb374&scoped=true&"
import script from "./vin.vue?vue&type=script&lang=js&"
export * from "./vin.vue?vue&type=script&lang=js&"
import style0 from "./vin.vue?vue&type=style&index=0&id=1c6eb374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6eb374",
  null
  
)

export default component.exports